import { useEffect, useRef } from "react";

export interface SummaryError { field: string; label: string; message: string }

export function FormErrorSummary({ errors, focusKey = 0 }: { errors: readonly SummaryError[]; focusKey?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => { if (focusKey > 0) ref.current?.focus(); }, [focusKey]);
  if (errors.length === 0) return null;
  return (
    <div ref={ref} className="alert alert-danger" role="alert" tabIndex={-1}>
      <h2 className="h6">請修正以下欄位</h2>
      <ul className="mb-0">{errors.map((error) => <li key={error.field}><a href={`#${error.field}`}>{error.label}：{error.message}</a></li>)}</ul>
    </div>
  );
}

